export default __webpack_public_path__ + "static/media/Girdle of the Judgment Bolt.20f7a052.jpg";